import React from "react"

import "./Review.scss"

const Review = (props) => {
  const stars = []
  for (let i = 0; i < props.stars; i++) {
    stars.push(i)
  }
  return (
    <div className="review">
      <div className="review__rating">
        { stars.map((item, index) => {
          return (
            <span key={index}>&#9733;</span>
          )
        })}
      </div>
      <div className="review__heading">{props.title}</div>
      <div className="review__text" dangerouslySetInnerHTML={{ __html: props.review }} />
      <div className="review__sub-text" dangerouslySetInnerHTML={{ __html: props.reviewer }} />
    </div>
  )
}

export default Review
